
import { ErrorDetailsDialogData } from '../../../../core/interfaces/error-details-dialog';

export enum ErrorDetailsDialogs {
  USER_PRODUCT_UPDATE_ERROR_DETAILS = 1,
  USER_PRODUCT_REMOVE_ERROR_DETAILS = 2
}

export namespace ErrorDetailsDialogsGetter {
	export function getDialogData(mode: ErrorDetailsDialogs): ErrorDetailsDialogData {
		switch (mode) {
      case ErrorDetailsDialogs.USER_PRODUCT_UPDATE_ERROR_DETAILS: {
        return {
          titleKey: 'users_edit_page.user_save_failed',
          code: 'errors.details.code',
          msg: 'errors.details.message',
          correlationId: 'errors.details.correlation_id',
          actionButtonKey: 'buttons.ok'
        };
      }
      case ErrorDetailsDialogs.USER_PRODUCT_REMOVE_ERROR_DETAILS: {
        return {
          titleKey: 'users_edit_page.remove_product_failed',
          code: 'errors.details.code',
          msg: 'errors.details.message',
          correlationId: 'errors.details.correlation_id',
          actionButtonKey: 'buttons.ok'
        };
      }
    }
  }
}